import Range from '../Range.react';

import React from 'react';
import MuteButton from './MuteButton.react';
import { isHandheld } from '../utils';

class VolumeToggle extends React.Component {
  constructor(props) {
    super(props);
    var initialVolume = 1;
    if (this.props && typeof this.props.volume === 'number') {
      initialVolume = this.props.volume;
    }
    this.state = {
      value: initialVolume
    };

    this.onChange = this.onChange.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onMouseOut = this.onMouseOut.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({value: nextProps.volume});
  }

  onChange(event) {
    this.setState({
      value: event.nativeEvent.target.value
    });

    if (this.props.video.muted) this.props.video.muted = false;

    try {
      this.props.video.volume = event.nativeEvent.target.value / 100;
    } catch (e) {}
  }

  onMouseOver() {
    this.setState({
      hover: true
    });
  }

  onMouseOut() {
    this.setState({
      hover: false
    });
  }

  render() {
    let slider;
    if (!isHandheld()) {
      let volumeClasses = 'b-volume-toggle';
      if (this.state.hover) {
        volumeClasses += ' active';
      }
      slider = (
        <div className={volumeClasses}>
          <Range
            min={0}
            max={100}
            onChange={this.onChange}
            value={this.props.video.muted ? 0 : this.state.value}
          />
        </div>
      );
    }

    return (
      <div className='b-volume'
        onMouseOver={this.onMouseOver}
        onMouseOut={this.onMouseOut}>
      <MuteButton video={this.props.video} muted={!this.state.value || this.props.video.muted} />
      {slider}
      </div>
    );
  }
}

export default VolumeToggle;
